module.exports = __webpack_public_path__ + "static/media/logo-tagline-trans.28fc0764.PNG";